import classnames from 'classnames/bind'
import { ALERT_CODES } from '~/@types/alert'

import { UpdateCustomerForm } from '@unlikelystudio/react-ecommerce-hooks'

import FormTemplate from '~/components/Abstracts/FormTemplate'
import { RichTextBlock } from '~/components/Abstracts/RichText'
import SectionTitle, {
  SectionTitleProps,
} from '~/components/Account/Logged/SectionTitle'
import { Customer } from '~/components/Account/Logged/types'

import useCustomerErrors from '~/hooks/account/useCustomerErrors'
import useAlerts from '~/hooks/useAlerts'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type InformationProps = SectionTitleProps & {
  className?: string
  checkboxText?: RichTextBlock
  customer?: Customer
}

function Information({ className, title }: InformationProps) {
  const onError = useCustomerErrors()
  const triggerAlert = useAlerts()

  return (
    <div className={cx(css.Information, className)}>
      <SectionTitle title={title} />
      <FormTemplate>
        <UpdateCustomerForm
          mutationOptions={{
            onSuccess: () => triggerAlert(ALERT_CODES.ENTITY_SAVED),
            onError: (error) => {
              const { errsGlobals, errsFields } = onError(error)
              const errors = Object.values(errsGlobals)

              if (errors?.length) {
                errors.map(triggerAlert)
              }

              if (!errors?.length && !Object.values(errsFields)?.length) {
                triggerAlert()
              }
            },
          }}
        />
      </FormTemplate>
    </div>
  )
}

Information.defaultProps = {}

export default Information
